import { AppBridge as AppBridgeModule } from '@shopline/app-bridge-js'

let instance = null

class AppBridge {
  constructor() {
    if (instance) {
      return instance
    }

    instance = this
  }

  async init(initConfig) {
    const timeoutPromise = new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error('Promise timed out'))
      }, 5000)
    })

    return Promise.race([AppBridgeModule.init(initConfig), timeoutPromise])
      .then(async (client) => {
        this.client = client
        this.client.currentUrl = await client.getCurrentUrl()

        return 'success'
      })
      .catch(() => 'failed')
  }
}

const appBridgeInstance = new AppBridge()

export default appBridgeInstance
